export const getInitialStatus = (counts?: ParticipationStatusesCounts): Participation['status'] => {
  const status =
    ['completed', 'booked', 'started', 'applied', 'requested', 'shortlisted'].find((status) => counts?.[status] > 0) ||
    'shortlisted';
  return status as Participation['status'];
};
